// src/components/Paginador.jsx
import React from "react";
import { useTranslation } from "react-i18next";

function Paginador({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
}) {
  const { t } = useTranslation();
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getVisiblePages = () => {
    if (totalPages <= 5)
      return Array.from({ length: totalPages }, (_, i) => i + 1);

    const pages = new Set();
    pages.add(1);

    if (currentPage <= 3) {
      pages.add(2);
      pages.add(3);
      pages.add(4);
      pages.add("...");
      pages.add(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.add("...");
      pages.add(totalPages - 3);
      pages.add(totalPages - 2);
      pages.add(totalPages - 1);
      pages.add(totalPages);
    } else {
      pages.add("...");
      pages.add(currentPage - 1);
      pages.add(currentPage);
      pages.add(currentPage + 1);
      pages.add("...");
      pages.add(totalPages);
    }
    return Array.from(pages);
  };

  const visiblePages = getVisiblePages();

  const handlePrevious = () => currentPage > 1 && onPageChange(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && onPageChange(currentPage + 1);
  const handleItemsPerPageChange = (e) => {
    onItemsPerPageChange(Number(e.target.value));
    onPageChange(1);
  };

  return (
    <div className="paginador">
      {/* Left: label + select */}
      <div className="paginador-left">
        <span className="paginador-label">
          {t("paginator.show", "Mostrar")}
        </span>
        <select
          className="paginador-select"
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          aria-label={t("paginator.itemsPerPage", "Items per page")}
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>

      {/* Right: arrows + pages */}
      <div className="paginador-right">
        <button
          className="paginador-arrow"
          onClick={handlePrevious}
          disabled={currentPage === 1}
          aria-label={t("paginator.prev", "Previous")}
          title={t("paginator.prev", "Previous")}
        >
          <i className="bi bi-chevron-left"></i>
        </button>

        <ul className="paginador-pages">
          {visiblePages.map((p, i) =>
            p === "..." ? (
              <li key={`ellipsis-${i}`} className="ellipsis" aria-hidden>
                …
              </li>
            ) : (
              <li
                key={`page-${p}`}
                className={p === currentPage ? "active" : ""}
                onClick={() => onPageChange(p)}
                aria-current={p === currentPage ? "page" : undefined}
                role="button"
                tabIndex={0}
              >
                {p}
              </li>
            )
          )}
        </ul>

        <button
          className="paginador-arrow"
          onClick={handleNext}
          disabled={currentPage === totalPages}
          aria-label={t("paginator.next", "Next")}
          title={t("paginator.next", "Next")}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  );
}

export default Paginador;
